import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { isEmpty } from 'lodash'

import { Asterisk } from 'components/asterisk/Asterisk'

import styles from './FormBlock.module.scss'

export const FormBlock = ({ title, readonlyView = null, isRequired, isReadonly, children, className }) => {
  const component = isReadonly ? readonlyView : children
  const classes = classNames([className, title && styles.component])

  if (isEmpty(title) && isEmpty(classes)) {
    return component
  }

  return (
    <div className={classes}>
      {title && (
        <div className={styles.title}>
          <span>
            {title}
            {isRequired && !isReadonly && <Asterisk space />}
          </span>
        </div>
      )}
      {component}
    </div>
  )
}

FormBlock.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node.isRequired,
  readonlyView: PropTypes.node,
  isReadonly: PropTypes.bool,
  isRequired: PropTypes.bool,
  className: PropTypes.string,
}
